module.exports = __webpack_public_path__ + "img/slide02.50716cc2.jpg";